export const PAGES_NAVBAR = {
  igaming: [
    {
      title: 'Início',
      path: 'inicio',
      icon: 'fi fi-sr-house-blank'
    },
    {
      title: 'Depósito',
      path: 'deposito',
      icon: 'fi fi-sr-credit-card'
    },
    {
      title: 'Premium',
      path: 'premium',
      icon: 'fi fi-sr-crown'
    },
    {
      title: 'Mais',
      path: 'mais',
      icon: 'fi fi-br-menu-burger'
    }
  ],
  ob: [
    {
      title: 'Início',
      path: 'inicio',
      icon: 'fi fi-sr-house-blank'
    },
    {
      title: 'Notícias',
      path: 'noticias',
      icon: 'fi fi-sr-newspaper'
    },
    {
      title: 'Depósito',
      path: 'deposito',
      icon: 'fi fi-sr-credit-card'
    },
    {
      title: 'Premium',
      path: 'premium',
      icon: 'fi fi-sr-crown'
    },
    {
      title: 'Aulas',
      path: 'aulas',
      icon: 'fi fi-sr-graduation-cap'
    },
    {
      title: 'Mais',
      path: 'mais',
      icon: 'fi fi-br-menu-burger'
    }
  ],
  sports: [
    {
      title: 'Início',
      path: 'inicio',
      icon: 'fi fi-sr-house-blank'
    },
    {
      title: 'Depósito',
      path: 'deposito',
      icon: 'fi fi-sr-credit-card'
    },
    {
      title: 'Premium',
      path: 'premium',
      icon: 'fi fi-sr-crown'
    },
    {
      title: 'Mais',
      path: 'mais',
      icon: 'fi fi-br-menu-burger'
    }
  ]
};
